<template>
    <div>
        <my-form
        class="form-page"
        v-model="form"
        table
        v-loading="loading"
        label-width="160px"
        @cancle="cancleHandler"
        :before-send="beforeSend"
         @submit="submitHandler">

            <template v-if="!isbd">
                <el-form-item
                label="标段名称"
                prop="bdcodes"
                :rules="newRule('标段名称', 'required')">
                    <cascader-bid
                        v-model="form.bdcodes"
                        2way="name"
                        :name.sync="form.bdnames"
                        :zbprocode="decryptzbprocode"
                        :SelectedBd="havedbdlist"
                    ></cascader-bid>
                </el-form-item>

                <el-form-item
                label="标段编码">
                <div class="bdcode-item">
                     {{form.bdcodes || '-'}}
                </div>
                   
                </el-form-item>
            </template>
            <template v-else>              
                <el-form-item
                label="标段名称">
                    {{form.bdnames}}
                </el-form-item>
                <el-form-item
                label="标段编码">
                    {{form.bdcodes}}
                </el-form-item>
            </template>

            <el-form-item
            class="table-full-row"
            label-width="0"
            prop="tableData"
            :rules="[{validator:tableDataValidate, trigger:['blur','change']}]">
                <el-popover 
                    trigger="click" 
                    width="400" 
                    v-model="copyshow">
                    <template>
                        <p>
                            <span style="color:#f56c6c;font-weight:bolder;">提示：</span>
                            请从文件中复制内容，粘贴到下面文本框中（不可输入），程序会自动解析并添加审查内容(只支持word表格和excel)
                        </p>
                        <el-input 
                            :rows="4" 
                            v-model="copytext" 
                            type="textarea" 
                            placeholder="请在此文本框粘贴要添加的评审项">
                        </el-input>
                        <div style="text-align:right;margin-top:10px">
                            <el-button 
                                type="primary" 
                                :disabled="copytext==''"
                                @click="pasteText(copytext)"
                                icon="el-icon-check" 
                                size="mini">
                                    确定
                            </el-button>
                        </div>
                        
                    </template>

                    <el-button slot="reference" size="small" type="primary" style="margin-bottom:5px">一键粘贴评审项</el-button>
                </el-popover>
         
                <my-table :data="form.tableData">
                    <el-table-column label="评审项">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.name"></el-input>
                        </template>
                    </el-table-column>

                    <el-table-column label="评审标准">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.value"></el-input>
                        </template>
                    </el-table-column>
                </my-table>
                <div class="tip">存在未填写完整的项</div>
            </el-form-item>

        </my-form>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'

import CascaderBid from './components/cascader-bid'

export default {
    mixins: [ FORM_PAGE_MIXIN ],
    components: { CascaderBid },
    data: () => ({
        form: {
            tableData: []
        },
        decryptzbprocode:'',
        isbd: false,
        show: false,
        xianzhi:'',
        copyshow: false,
        copytext:'',
        loading:false,
        havedbdlist:[]
    }),      
    watch: {
        
    },
    methods: {
        // 将复制的内容重组后 渲染到表格
        pasteText(val){
            this.loading = true
            var that = this
            var tablelist = []
            
            var arr = val.split('\n')
            arr.forEach(function(item,index){
                var num = item.indexOf('\t');
                if(num>=0){
                    var list = item.split('\t')
                    var obj = {}
                    obj['name'] = list[0]
                    obj['value'] = list[1]
                    tablelist.push(obj)
                }
            })
            if(tablelist.length<15){
                var num = 15 - tablelist.length
                for(var i = tablelist.length; i<15; i++){
                    tablelist[i] = {name:'',value:''}
                }
            }else{
                tablelist[tablelist.length+1] = {name:'',value:''}
            }
            that.form.tableData = tablelist
            
            setTimeout(() => {
                that.loading = false
            }, 2000);
          
        },
        
        beforeSend(send) {
            var tableData = this.form.tableData.reduce((arr, item) => {
                if(item.name && item.value) {
                    var itemescape=clone(item)
                    itemescape.name=escape(itemescape.name)
                    itemescape.value=escape(itemescape.value)
                    arr.push({name:escape(itemescape.name),value:escape(itemescape.value)});
                };
                return arr;
            }, []);
            this.form.data = JSON.stringify(tableData);
            send();
        },
        initTableData(nrList) {
            const TABLE_LENGTH = 15;

            var tableData = nrList.map(item => ({
                name: item.content,
                value: item.condition
            }));
            do {
                tableData.push({
                    name: '',
                    value: ''
                });
            } while (tableData.length < TABLE_LENGTH);
            return tableData;
        },
        tableDataValidate(rule, value, callback) {
             
            if(value.every(row => {  
                if(!(!row.name^!row.value)==true){
                    $(".tip").css("display","none");
                    $(".el-input__inner").css("border-color","#DCDFE6");
                }
                this.xianzhi= !(!row.name ^!row.value)
                return !(!row.name ^!row.value)

            })) {
                callback();
            } else {
                  $(".el-table__body .el-input__inner").css("border-color","#F56C6C");
                callback(new Error('存在未填写完整的项'));
            };
        },
        saveHandler( cb) {
                cb();
            },
        submitHandler:function(){
            var that=this;
           
            if(this.form.data=='[]'){
                $(".tip").css("display","block");
                $(".el-table__body .el-input__inner").css("border-color","#F56C6C");
                return
            } 
            this.form.zbprocode = this.getQuery('zbprocode');
            that.$post(`${this.getGetters('bidUrl')}/Zbdl/zgsc/xingtai/addzgscnr.json`,this.form,(data, res) => {
                if (res.result) {
                    ShowMsg(res.msg,'success')    
                    this.cancleHandler();
                } else {
                    ShowMsg(res.msg)
                }
                $(".tip").css("display","none");
                $(".el-input__inner").css("border-color","#DCDFE6");
            });
        }, 
        // 一键粘贴
        paste(){
           
        }
    },
        
    created() {
        this.jspInit(`${this.getGetters('bidUrl')}/Zbdl/zgsc/xingtai/setzgscnr.json`, {
            zbprocode: this.getQuery('zbprocode'),
            bdcode:this.getQuery('bdcode'),  
        }, data => {
            this.jspDataInit(data, ['isbd', 'show']);
            this.decryptzbprocode=data.decryptzbprocode
            this.form.bdcode=data.bdcode
            if(data.isbd) {
                this.form.bdcodes = data.bdcode;
                this.form.bdnames = data.bdname;
            };
            this.form.tableData = this.initTableData(data.nrlist || []);
            this.havedbdlist = data.havedbdlist
        });
    }
}
</script>

<style scoped lang="scss">
 .bdcode-item {
    word-break: break-all;
    white-space: pre-wrap;
}
.tip {
    color: #F56C6C;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    bottom: 0;
    display: none;
    z-index: 100;

}
/deep/ .el-form-item__error {
    z-index: 100;
}
/deep/ .el-textarea__inner{
    height: 200px !important;
}
</style>
